import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  backToSERP: {
    defaultMessage: 'Zurück zum Suchergebnis',
    id: 'breadcrumb.button.back-to-serp',
  },
  backToMBA: {
    defaultMessage: 'zurück',
    id: 'breadcrumb.button.back-to-mba',
  },
});
